import Fade, { FadeProps } from "@mui/material/Fade";
import Collapse from "@mui/material/Collapse";
import { useRef } from "react";

/**
 * an MUI animation, but when `onExit` is triggered, the height is set to `0px`
 * so that another suggestions container won't cause cumulative shift layout when mounted.
 * this will simplify the fade/collpase container too, so this component already wrap `Fade` & `Collapse` with a `div`
 */
const ChatSuggestionAnimation = ({
    children,
    onExit,
    style,
    in: _in,
    ...props
}: Omit<FadeProps, "children"> & { children: React.ReactNode }) => {
    const ref = useRef<HTMLDivElement>(null);

    return (
        <Collapse
            ref={ref}
            in={_in}
            unmountOnExit
            timeout={300}
            onEntered={e => {
                const scrollParentEl = e.parentElement?.parentElement;
                scrollParentEl?.scrollTo({ top: scrollParentEl.scrollHeight, behavior: "smooth" });
            }}
            onExit={e => {
                e.style.height = "0px";
                onExit?.(e);
            }}
            {...props}>
            <Fade in={true} timeout={500}>
                <div style={style} data-testid="auto-id-5692eb52-2925-4756-9ca6-13c7b328cfcf">
                    {children}
                </div>
            </Fade>
            <div style={{ height: "1rem", width: "100%" }} data-testid="auto-id-62563b12-f7b7-4030-b1b4-c6a630488e08" />
        </Collapse>
    );
};

export default ChatSuggestionAnimation;
